<template>
  <div id="credentials">
    <div id="content">
      <!-- <Header
        @update="update()"
        :page="'credential_update'"
        :title_one="'credentials'"
        :action_one="'update'"
      ></Header> -->
      <Header :page="'credential_update'" :title_one="'credentials'"></Header>

      <div class="description">
        <span
          v-html="
            $t('credentials.description_' + user.event_name.toLowerCase().replace(/ /g, ''))
          "
        ></span>
      </div>

      <div class="form-credentials">
        <div class="label">{{ $t("credentials.pick_place") }}</div>
        <v-select
          :items="Object.values(locations)"
          v-model="credential.location_id"
          :item-text="item => $t('credentials.hotel.' + item.name)"
          item-value="id"
          style="width: 100%; display: inline-block; margin-bottom: 15px "
          v-bind:class="error.location_id ? 'input-error' : ''"
          :disabled="false"
        ></v-select>
        <div class="info" v-if="location_id">
          {{ locations[location_id].address }}<br />{{
            locations[location_id].contact
          }}
        </div>

        <div class="label">{{ $t("credentials.pick_day") }}</div>
        <v-select
          :disabled="false || credential.location_id == undefined"
          :items="Object.values(dateRangeParsed)"
          v-model="credential.daterange_id"
          :item-text="'fulldate'"
          item-value="id"
          style="width: 100%; display: inline-block; margin-bottom: 15px "
          v-bind:class="error.daterange_id ? 'input-error' : ''"
        ></v-select>

        <div class="label">{{ $t("credentials.pick_contact_name") }}</div>
        <v-text-field
          :disabled="false"
          v-model="credential.contact_name"
          style="width: 100%; display: inline-block; margin-bottom: 15px"
          v-bind:class="error.contact_name ? 'input-error' : ''"
        ></v-text-field>

        <div class="label">{{ $t("credentials.pick_contact_phone") }}</div>
        <v-text-field
          :disabled="false"
          v-model="credential.contact_phone"
          style="width: 100%; display: inline-block; margin-bottom: 15px"
          v-bind:class="error.contact_phone ? 'input-error' : ''"
        ></v-text-field>
        <div class="actions">
          <div
            v-if="event.credentials"
            class="btn"
            id="addedit"
            style="width: fit-content"
            @click="update()"
          >
            {{ $t("update") }}
          </div>
        </div>
      </div>
      <SuccessPopup
        @close="closePopup()"
        @input="closePopup()"
        :dialog="success"
      ></SuccessPopup>
    </div>
  </div>
</template>
<script>
/* global isEmpty */
import i18n from '@/i18n'
import Header from '@/components/layout/Header'
import SuccessPopup from '@/components/ui/SuccessPopup.vue'

export default {
  name: 'credentials',
  components: {
    Header,
    SuccessPopup
  },
  data () {
    return {
      credential: {
        location_id: null,
        daterange_id: null,
        contact_name: null,
        contact_phone: null
      },
      error: {
        location_id: false,
        daterange_id: false,
        contact_name: false,
        contact_phone: false
      },
      location_id: undefined,
      locations: [],
      dateRange: [],
      success: false
    }
  },
  computed: {
    user () {
      return this.$store.getters['user/getUser']
    },

    event () {
      return this.$store.getters['getCurrentEvent']()
    },

    dateRangeParsed () {
      if (this.credential.location_id !== '') {
        var result = []
        for (var key in this.dateRange) {
          var item = { ...this.dateRange[key] }
          if (String(item.credentials_locations_id) === String(this.credential.location_id)) {
            item.fulldate = i18n
              .t('credentials.daterange')
              .replace('{date}', item.start.date)
              .replace('{hour1}', i18n.t(item.start.hour))
              .replace('{hour2}', item.end.hour)
            result.push(item)
          }
        }
        return Object.values(result)
      }
      return []
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      this.$overlay.show()
      var self = this

      // scroll to top
      window.scroll(0, 0)

      if (this.user.admin) {
        this.$store.dispatch('club/loadClubEvent', {
          club_id: this.user.club_id,
          event_id: this.user.event_id
        })
      }

      this.$store
        .dispatch('team/loadCredentialsInfo', { event_id: this.user.event_id })
        .then(function (data) {
          self.locations = data.locations
          self.dateRange = data.daterange
          self.$store
            .dispatch('team/loadCredential', {
              team_id: self.$route.params.team_id
            })
            .then(function (response) {
              console.log(response)
              if (response.status) {
                self.credential = Object.assign({}, response.data)
                self.location_id = response.data.location_id
              }

              self.$overlay.hide()
            })
        })
    },

    update () {
      var validate = true
      this.success = false

      isEmpty(this.credential.location_id)
        ? (this.error.location_id = true) && (validate = false)
        : (this.error.location_id = false)

      isEmpty(this.credential.daterange_id)
        ? (this.error.daterange_id = true) && (validate = false)
        : (this.error.daterange_id = false)

      isEmpty(this.credential.contact_name)
        ? (this.error.contact_name = true) && (validate = false)
        : (this.error.contact_name = false)

      isEmpty(this.credential.contact_phone)
        ? (this.error.contact_phone = true) && (validate = false)
        : (this.error.contact_phone = false)

      if (validate) {
        var self = this
        this.$store
          .dispatch('team/updateCredential', {
            team_id: this.$route.params.team_id,
            data: JSON.stringify(this.credential)
          })
          .then(function () {
            self.success = true
          })
      }
    }
  },

  watch: {
    $route: 'load'
  }
}
</script>
<style lang="scss" scoped>
.mobile {
  display: none;
}

#content {
  padding: 0 12px !important;
  padding-bottom: 50px !important;

  .row {
    background-color: #f5f5f5;
    border-radius: 3px;
    text-align: center;
    overflow: hidden;
    margin-bottom: 24px;
    padding: 6px 12px;
    height: auto;
    // min-height: 100px;

    &.nobackground {
      background-color: unset;
    }

    .item {
      display: inline-block;
      margin-bottom: 6px;
      width: 100%;

      &.mid {
        width: 50%;
      }

      .alergy {
        color: inherit;
        font-size: inherit;
        font-weight: inherit;

        &:after {
          content: ", ";
        }
        &:last-of-type:after {
          content: "";
        }
      }
    }

    .label,
    .value {
      display: inline-block;
      font-size: 15px;
    }
    .label {
      width: 100px;
      text-align: right;
      margin-right: 12px;
      text-transform: uppercase;
      font-size: 12px;

      &:after {
        content: ":";
      }
    }
    .value {
      font-weight: bold;
    }
  }

  .form-credentials,
  .actions {
    margin: 0 auto;
    width: fit-content;
  }

  .form-credentials {
    margin-top: 70px;
    padding: 20px;
    background-color: #f5f5f5;
    border-radius: 2px;

    .input-error {
      border: 1px solid;
      border-color: $alert-color !important;
      border-radius: 2px;
      &::placeholder {
        color: $alert-color !important;
        opacity: 0.5;
      }
      .v-input__slot {
        border-color: $alert-color;
      }
    }

    .info {
      width: 100%;
      text-align: left;
      margin-right: 12px;
      margin-bottom: 5px;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 12px;
    }

    .v-input {
      height: 35px !important;
    }
  }

  .title {
    font-size: 16px !important;
    font-weight: bold;
    color: #191919;
    display: block;
    width: 100%;
    margin: 6px;
    font-family: AvantGarde-Bold !important;
    text-transform: uppercase;
    padding: 2px 0;

    &.sub {
      margin-left: 12px;
    }
  }

  .credentials {
    background: none;
    width: 100%;
    overflow: hidden;
    text-align: left;

    .credentials-role,
    .credentials-name {
      @include text-ellipsis();
      display: block;
      font-size: 24px;
      color: $main-color;
      width: 100%;
      padding: 2px;
    }

    .credentials-role {
      margin-right: 6px;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 16px;
      line-height: 16px;
    }
  }

  .left,
  .right {
    width: 50%;
    display: inline-block;
    padding: 12px;
  }
}

@include media("<=desktop") {
  #content {
    padding: 12px !important;

    .left,
    .right {
      width: 100%;
      display: block;
      padding: 0;
    }
  }
}

@include media(">phone", "<tablet") {
  #content {
    .row {
      .item {
        &.mid {
          width: 100%;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.mainButton {
  width: 150px !important;
  padding: 0;
  margin: 0;
  height: 100%;
  min-width: 40px;
  outline: none;
  cursor: pointer;
  font-size: 8pt;
  font-family: Speedee-Bold;
  border-radius: 3px;
  border: 1px solid #fc8926;
  text-transform: uppercase;
  background-color: transparent;
  color: #c55c00;
  height: 40px;
  padding: 0;
  font-family: Roboto-Bold;
  font-size: 14px;
  line-height: 14px;
  transition: background-color 0.5s ease;
  float: left;

  &:hover {
    background-color: #fc8a2623 !important;
  }
}

.section {
  float: left;
  display: block;
  width: 100%;
}

.search {
  float: right;
}

.dataTable {
  > div {
    table {
      text-align: center;
      width: 100%;
      margin: 20px auto 0;
      border-radius: 5px;

      overflow: visible;
      min-width: 600px;

      th {
        background-color: $secondary-color;
        background-color: #ddd;
      }
      td,
      th {
        border: 1px solid $secondary-color;
        padding: 12px !important;
        text-align: left;
        border-left: 0;
        border-right: 0;
        min-width: 60px;
      }

      tr:nth-child(even) {
        background-color: #f7f7f7;
      }

      th {
        font-weight: normal;
        border: 0 solid $secondary-color;
        color: $main-color;
        color: #333;
        padding: 20px;
        text-transform: uppercase;
      }
      th.column[role="columnheader"] {
        padding: 20px 12px 12px 12px !important;
      }

      th:nth-child(1) {
        width: 20%;
      }

      th:nth-child(2) {
        width: 20%;
      }

      th:nth-child(3) {
        width: 20%;
      }

      th:nth-child(4) {
        width: 20%;
      }

      th:nth-child(5) {
        width: 10%;
      }

      th:nth-child(6) {
        width: 10%;
      }

      // tr:last-child {
      //   // border-bottom: 4px solid $main-color;
      // }
    }
  }
}
</style>
